// extracted by mini-css-extract-plugin
export default {"delete":"photoDelete_delete__ppiEj"};